import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import {
  selectedBrandSelector,
  setGlobalBrand,
  userBrandsSelector,
} from "@/shared/store/brandSlice";

type BrandLike = {
  id?: string | number | null;
};

const isPresent = (value: string | null) => value !== null && value !== "";
const SOCIAL_POSTING_SOURCE = "social_posting";

export const useUrlSelectedBrand = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const selectedBrand = useSelector(selectedBrandSelector) as BrandLike | null;
  const userBrands = useSelector(userBrandsSelector) as BrandLike[];

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const source = searchParams.get("source");
    const brandId = searchParams.get("brand_id");
    if (source !== SOCIAL_POSTING_SOURCE) return;
    if (!isPresent(brandId) || !Array.isArray(userBrands)) return;

    const matchingBrand = userBrands.find(
      (brand) => String(brand?.id) === String(brandId)
    );

    if (!matchingBrand) return;
    if (String(selectedBrand?.id) === String(matchingBrand.id)) return;

    dispatch(setGlobalBrand(matchingBrand));
  }, [dispatch, location.search, selectedBrand?.id, userBrands]);
};
